module.exports = __webpack_public_path__ + "img/left-menu.c626db5f.jpg";